import {
  Edit,
  SimpleForm,
  TextInput,
  PasswordInput,
  usePermissions,
  useNotify,
  useRedirect,
    useDataProvider,
} from "react-admin";

const UserEdit = () => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const handleSubmit = async (values) => {
    try {
      await dataProvider.update("users", {
        id: values.id,
        data: values,
      });

      notify("User updated successfully 🎉", {
        type: "success",
      });

      redirect("/users");
    } catch (error) {
      notify(error.message || "Error updating user", {
        type: "error",
      });
    }
  };

   console.log("inside the edit form",permissions)
   console.log("inside the edit form",!(permissions.includes("users.edit") || permissions.includes("*")))
  // Allow user.edit OR super-admin (*)
  if (!(permissions.includes("users.edit") || permissions.includes("*") || permissions.includes("users.*"))) {
    return null;
  }



  return (
    <>
      <p>Edit User</p>
      <Edit title="Edit User">
        <SimpleForm onSubmit={handleSubmit}>
          <TextInput source="name" required />
          <TextInput source="email" type="email" required />
          
        </SimpleForm>
      </Edit>
    </>
  );
};

export default UserEdit;
